import "./ClientLoginLayout.scss"
import React from 'react'

import CertificationsFooter from "./../../../components/certification-footer/CertificationsFooter"
import { ReactComponent as DarkWaves } from "./../../../assets/client/login/DarkWaves.svg"
import { ReactComponent as LightWaves } from "./../../../assets/client/login/LightWaves.svg"
import { ReactComponent as JcrLogo } from "./../../../assets/logo/JC_logo.svg"


function ClientLoginLayout({children}) {
  return (
    <div className="ClientLoginLayout h-screen px-8 flex align-items-center justify-content-center relative overflow-hidden">
      <div className="grid justify-content-between w-full">
        <div className="col-5 h-22rem flex flex-column justify-content-between">
          <div className="WelcomeTextContainer">
            <h3 className="WelcomeText text-2xl font-medium py-5">Welcome to</h3>
            <JcrLogo className="JcrLogo" />
          </div>
          <CertificationsFooter isLoginPage={true} />
        </div>
        <div className="col-5 justify-content-between">
          {children}
        </div>
      </div>
      <div className="DarkWaves absolute pointer-events-none">
        <DarkWaves />
      </div>
      <div className="LightWaves absolute pointer-events-none">
        <LightWaves />
      </div>
    </div >
  )
}

export default ClientLoginLayout